import { useState } from 'react';
import { Button, Modal, Input } from '@rabbit/elements/shared-components';
import { Formik, Form } from 'formik';
import { DRDocType } from '@rabbit/firebase/react';
import { DTConsumer_Private } from '@rabbit/data/types';
import { DR_Consumer_Private, usePortalDocumentEditor } from '@rabbit/data/portal';
import { AGE_RANGE_OPTIONS } from '@rabbit/olive/utils/consts';
import * as Yup from 'yup';

type AgeRangeModalProps = {
  personaId: string;
  onSaved: () => void;
};

const validationSchema = Yup.object({
  age_bracket: Yup.string().required('Required'),
});

export const AgeRangeModal: React.FC<AgeRangeModalProps> = ({
  personaId,
  onSaved,
}) => {
  const { body, update, commit, isReady } = usePortalDocumentEditor(
    DR_Consumer_Private as DRDocType<DTConsumer_Private>,
    personaId
  );
  const [saving, setSaving] = useState(false);

  if (!body) return null;

  const handleSubmit = async (values: { age_bracket: string }) => {
    if (!isReady || !body) return;
    try {
      setSaving(true);
      update({
        ...body,
        age_bracket: values.age_bracket,
      } as DTConsumer_Private);
      await commit();
      onSaved();
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      kind="generic"
      className="m-5 max-w-[480px]"
      settings={{
        title: 'Please select your age range',
        handleClose: () => {},
      }}
    >
      <Formik
        initialValues={{ age_bracket: body.age_bracket ?? '' }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ errors }) => (
          <Form className="flex flex-col gap-4 p-2">
            <Input
              type="select"
              name="age_bracket"
              label="Age range"
              settings={{
                id: 'age_bracket',
                placeholder: 'Select your age range',
                options: AGE_RANGE_OPTIONS,
                errors,
              }}
            />
            <div className="flex justify-end gap-2">
              <Button
                kind="primary"
                type="submit"
                disabled={!!errors.age_bracket}
                loading={saving || !isReady}
              >
                Save and continue
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

